module.exports = __webpack_public_path__ + "img/subjective-detection_how_it_works.1e50ba6d.svg";